import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Order} from '../models/order';

export const orderExchangeActionTypes = {
  LOAD: type('[order] Load Exchange'),
  LOAD_SUCCESS: type('[order] Load Exchange Success'),
  LOAD_FAIL: type('[order] Load Exchange Fail'),
  CLEAR: type('[order] Exchange Clear'),
};

export class LoadExchangeAction implements Action {
  readonly type = orderExchangeActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadExchangeSuccessAction implements Action {
  readonly type = orderExchangeActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Order) {}
}

export class LoadExchangeFailAction implements Action {
  readonly type = orderExchangeActionTypes.LOAD_FAIL;
  constructor(public payload?: number) {}
}
export class ExchangeClearAction implements Action {
  readonly type = orderExchangeActionTypes.CLEAR;
  constructor() {}
}

